import type { TenantAccess } from '@konyaxl/shared';
import { useState } from 'react';
import { ImageScanPage } from '../components/ImageScanPage.js';
import { getChannel, hasHardwareScanner } from '../core/native.js';
import { BulkQueryPage } from './BulkQueryPage.js';
import { RecordsPage } from './RecordsPage.js';

interface Props {
  tenant: TenantAccess;
  onBack: () => void;
}

type Sekme = 'kayitlar' | 'resim' | 'toplu';

/**
 * Sorgulama ekranları tek çatı altında.
 *
 * Üçü de aynı soruyu farklı girdiyle soruyor: "bu kod sistemde var mı".
 * Ana ekranda ayrı düğmeler olarak durduklarında kategori kartı beş düğmeye
 * çıkıyordu ve hangisinin ne yaptığı kart üstünden anlaşılmıyordu.
 */
export function KayitlarPage({ tenant, onBack }: Props) {
  const [sekme, setSekme] = useState<Sekme>('kayitlar');

  /**
   * El terminalinde yalnızca kayıt listesi var: resim seçmek ve liste
   * yapıştırmak masaüstü işleri. Toplu sorgu ayrıca dar ekranda
   * kullanılamaz — girdisi yüzlerce satır, çıktısı geniş bir tablo.
   */
  const masaustu = getChannel() === 'desktop' && !hasHardwareScanner();

  const sekmeler: Array<{ id: Sekme; ad: string }> = [
    { id: 'kayitlar', ad: 'Kayıtlar ve arama' },
    ...(tenant.features.imageScan && !hasHardwareScanner()
      ? [{ id: 'resim' as const, ad: 'Resimden sorgula' }]
      : []),
    ...(tenant.features.bulkQuery && masaustu
      ? [{ id: 'toplu' as const, ad: 'Toplu gönderi sorgula' }]
      : []),
  ];

  // Tek seçenek varsa şerit bir şey anlatmaz, yer kaplar.
  const serit =
    sekmeler.length > 1 ? (
      <div className="sorgu-sekmeler ust">
        {sekmeler.map((s) => (
          <button
            key={s.id}
            className={s.id === sekme ? 'aktif' : ''}
            onClick={() => setSekme(s.id)}
          >
            {s.ad}
          </button>
        ))}
      </div>
    ) : undefined;

  if (sekme === 'resim') {
    return <ImageScanPage tenant={tenant} onBack={onBack} sekmeler={serit} />;
  }

  if (sekme === 'toplu') {
    return <BulkQueryPage tenant={tenant} onBack={onBack} sekmeler={serit} />;
  }

  return <RecordsPage tenant={tenant} onBack={onBack} sekmeler={serit} />;
}
